export const enum ForumsModalType {
  FORUM_POST_MODAL = 'FORUM_POST_MODAL',
}
